import React, { ChangeEvent, useEffect, useState } from "react";
import "./reasonDelete.css";
import { Button } from "components/button";
import Radio from "components/radio-item/Radio";
import TextArea from "components/textarea/textarea";
import i18n from "../../i18n";
import { userDeleteApi } from "modules/delete-user";
import { useNavigate } from "react-router-dom";
import { SpinnerPage } from "components/spinner";

const ReasonDeletePage = () => {
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [reason, setReason] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleRadioChange = (value: string) => {
    setSelectedOption(value);
  };

  const handleReasonChange = (event: ChangeEvent<HTMLInputElement>) => {
    setReason(event.target.value);
  };

  const reasonList = [
    { value: "option1", label: i18n.t("OptionReason1") },
    { value: "option2", label: i18n.t("OptionReason2") },
    { value: "option3", label: i18n.t("OptionReason3") },
    { value: "Alasan lainnya", label: i18n.t("OptionReason4") },
  ];

  useEffect(() => {
    if (
      (reason.length < 10 && selectedOption === i18n.t("OptionReason4")) ||
      !selectedOption
    ) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [reason, selectedOption]);

  const handleSubmitReason = async () => {
    setIsLoading(true);
    try {
      const value: string =
        selectedOption === i18n.t("OptionReason4")
          ? reason
          : selectedOption ?? "";
      const response = await userDeleteApi.reasonDeleteCurrentUser(value);
      if (response) {
        navigate("/success");
        setIsLoading(false);
      } else {
        navigate("/error");
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      navigate("/error");
    }
  };

  return (
    <React.Fragment>
      <SpinnerPage isShowLoading={isLoading} />
      <div
        className="container wrapper-reason"
        data-testid="container-wrapper-reason"
      >
        <div className="content" data-testid="content">
          <div
            className="radio-buttons d-flex flex-column mb-3"
            data-testid="radio-buttons"
          >
            <h2
              className="text-header-reason"
              data-testid="text-header-reason"
            >
              {i18n.t("HeaderReasonDeleteAccount")}
            </h2>
            <h3 className="subheader" data-testid="subheader">
              {i18n.t("SubHeaderReasonDeleteAccount")}
            </h3>
            <div className="wrapper-option" data-testid="wrapper-option">
              {reasonList.map((reason) => (
                <React.Fragment key={reason.value}>
                  <Radio
                    reason={reason}
                    selectedOption={selectedOption}
                    handleRadioChange={handleRadioChange}
                  />
                </React.Fragment>
              ))}
            </div>
            {selectedOption === i18n.t("OptionReason4") && (
              <div className="form-group" data-testid="form-group">
                <TextArea
                  reason={reason}
                  handleReasonChange={handleReasonChange}
                  maxLength={100}
                  minLength={10}
                  dataTestId="textarea-reason"
                />
              </div>
            )}
          </div>
          <Button
            handleClick={() => {
              handleSubmitReason();
            }}
            textButton="submitDeleteReason"
            isDisabled={isDisabled}
            customClassName="submit-button"
            dataTestId="submit-button"
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ReasonDeletePage;
